// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 150px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-reg-ghost {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  border: 1px solid #0669B3;
  background: white;
  color: #0669B3;
  height: 30px;
  transition: 0.2s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 150px;
}
.action-button-reg-ghost:hover {
  transform: scale(1.015);
  background: #0669B3;
  color: white;
  border: none;
}
.action-button-reg-ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-reg-ghost-long {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  border: 1px solid #0669B3;
  background: white;
  color: #0669B3;
  min-height: 30px;
  transition: 0.2s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 250px;
}
.action-button-reg-ghost-long:hover {
  transform: scale(1.015);
  background: #0669B3;
  color: white;
  border: none;
}
.action-button-reg-ghost-long:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-300 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 300px;
  margin: 40px 10px;
}
.action-button-300:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-300:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small-trashCan {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 20px;
  transition: 0.1s ease;
  width: 40px;
  margin: 0 10px;
}
.action-button-small-trashCan:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small-trashCan:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: 2px solid #0669B3;
  background: #A7A9AC;
  background: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-hide-dropdown {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border: none;
  background: #0669B3;
  background: #A7A9AC;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 100%;
}
.action-button-hide-dropdown:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-hide-dropdown:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-admin {
  border-radius: 3px;
  cursor: pointer;
  border: none;
  background: #0d6efd;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 7px;
  font-weight: 600;
  font-size: 0.85em;
  margin-top: 10px;
  transition: 0.1s ease-in-out;
}
.action-button-admin:hover {
  padding-left: 30px;
}
.action-button-admin:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.back-to-admin-home {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  min-width: 260px;
}
.back-to-admin-home:hover {
  transform: scale(1.015);
  background: #1786DB;
}

.close-x-icon-button {
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  border: none;
  padding: 3px;
  position: relative;
  bottom: 20px;
  right: 20px;
  color: #808080;
  background: white;
  border: 2px solid #808080;
  font-size: 12px;
  font-weight: 600;
}

.action-button-table-edit {
  border-radius: 5px;
  width: 25px;
  height: 25px;
  background: none;
  border: none;
  cursor: pointer;
}

.action-button-group {
  border-radius: 3px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 30px;
  transition: 0.1s ease;
  background: none;
  border: none;
  padding: 15px 10px;
  font-size: 14px;
}
.action-button-group:hover {
  background: #D1D3D4;
}
.action-button-group:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-circle-green {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: rgb(53, 148, 53);
  color: white;
  height: 50px;
  width: 50px;
  transition: 0.1s ease;
  font-size: 40px;
}
.action-button-circle-green:hover {
  transform: scale(1.02);
  background: rgb(85, 179, 85);
}
.action-button-circle-green:disabled {
  opacity: 0.5;
  background: #A7A9AC;
  cursor: not-allowed;
}

.action-button-circle-red {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  align-items: center;
  border: none;
  background: rgb(201, 33, 3);
  color: white;
  height: 50px;
  width: 50px;
  transition: 0.1s ease;
  font-size: 40px;
}
.action-button-circle-red:hover {
  transform: scale(1.02);
  background: rgb(234, 64, 34);
}
.action-button-circle-red:disabled {
  opacity: 0.5;
  background: #A7A9AC;
  cursor: not-allowed;
}

@media only screen and (max-width: 1190px) {
  .action-button-opt-out-locations {
    font-size: 12px;
  }
}
@media only screen and (max-width: 1085px) {
  .action-button-opt-out-locations {
    width: 160px;
    padding: 5px;
    height: 45px;
  }
}
@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ActionButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAWF;;AARA;ECTI,kBDUsB;ECWtB,2CAAA;EDTA,eAAA;EACA,YAAA;EACA,mBDcS;ECbT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAWJ;AATI;EACE,uBAAA;EACA,mBDKa;ACMnB;AATI;EACE,YAAA;EACA,mBAAA;AAWN;;AAPE;EChCE,kBDiCsB;ECZtB,2CAAA;EDcA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,cDXS;ECYT,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDpBO;ECqBP,YAAA;EACA,YAAA;AAUN;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECzDE,kBD0DsB;ECrCtB,2CAAA;EDuCA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,cDpCS;ECqCT,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD7CO;EC8CP,YAAA;EACA,YAAA;AAUN;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AANA;ECnFI,kBDoFsB;EC/DtB,2CAAA;EDiEA,eAAA;EACA,YAAA;EACA,mBD5DS;EC6DT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBDpEa;AC6EnB;AAPI;EACE,YAAA;EACA,mBAAA;AASN;;AANA;ECxGI,kBDyGsB;ECpFtB,2CAAA;EDsFA,eAAA;EACA,YAAA;EACA,mBDjFS;ECkFT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBDzFa;ACkGnB;AAPI;EACE,YAAA;EACA,mBAAA;AASN;;AANE;EC7HE,kBD8HsB;ECzGtB,2CAAA;ED2GA,eAAA;EACA,YAAA;EACA,mBDtGS;ECuGT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBD9Ga;ACuHnB;AAPI;EACE,YAAA;EACA,mBAAA;AASN;;AANE;EClJE,kBDmJsB;EC9HtB,2CAAA;EDgIA,eAAA;EACA,YAAA;EACA,mBD3HS;EC4HT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBDnIa;AC4InB;AAPI;EACE,YAAA;EACA,mBAAA;AASN;;AANE;ECvKE,kBDwKsB;ECnJtB,2CAAA;EDqJA,eAAA;EACA,YAAA;EACA,mBDhJS;ECiJT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBDxJa;ACiKnB;AAPI;EACE,YAAA;EACA,mBAAA;AASN;;AALE;EC7LE,kBD8LsB;ECzKtB,2CAAA;ED2KA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDzKS;EC0KT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBDjLa;ACyLnB;AANI;EACE,YAAA;EACA,mBAAA;AAQN;;AALG;ECrNC,kBDsNsB;ECjMtB,2CAAA;EDmMA,eAAA;EACA,yBAAA;EACA,mBDrMI;ECsMJ,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBD7ME;ACqNR;AANI;EACE,YAAA;EACA,mBAAA;AAQN;;AALE;EC1OE,kBD2OsB;ECtNtB,2CAAA;EDwNA,eAAA;EACA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,mBDtNS;ECuNT,mBD9NI;EC+NJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAOJ;AALI;EACE,uBAAA;EACA,mBDhOa;ACuOnB;AALI;EACE,aAAA;EACA,mBAAA;AAON;;AAHI;ECrQA,kBDsQsB;EACtB,eAAA;EACA,YAAA;EACA,mBDrQa;ECsQb,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AAMJ;AAJI;EACE,kBAAA;AAMN;AAJI;EACE,YAAA;EACA,mBAAA;AAMN;;AAFE;EC5RE,kBD6RsB;ECxQtB,2CAAA;ED0QA,eAAA;EACA,YAAA;EACA,mBDrQS;ECsQT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBD5Qa;ACiRnB;;AADE;EC7SE,mBD8SsB;EACtB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cDnSI;ECoSJ,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAIJ;;AADE;EChUE,kBDiUsB;EACtB,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAIJ;;AAFE;ECxUE,kBDyUsB;EACtB,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAKJ;AAHI;EACE,mBDjUE;ACsUR;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AACG;EC/VC,kBDgWsB;EC3UtB,2CAAA;ED6UA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;AAEJ;AAAI;EACE,sBAAA;EACA,4BAAA;AAEN;AAAI;EACE,YAAA;EACA,mBD9VE;EC+VF,mBAAA;AAEN;;AACG;ECvXC,kBDwXsB;ECnWtB,2CAAA;EDqWA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;AAEJ;AAAI;EACE,sBAAA;EACE,4BAAA;AAER;AAAI;EACE,YAAA;EACA,mBDvXE;ECwXF,mBAAA;AAEN;;AAIE;EACE;IACE,eAAA;EADJ;AACF;AAIE;EACE;IACE,YAAA;IACA,YAAA;IACA,YAAA;EAFJ;AACF;AAKE;EACE;IACE,iBAAA;IACA,gBAAA;EAHJ;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.button-with-status-container {\n  display: flex\n}\n.status-on-button {\n  position: relative;\n  bottom: 10px;\n  right: 20px\n}\n\n.action-button-reg {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n    width: 150px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  \n  .action-button-reg-ghost {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    border: 1px solid $pearl-blue;\n    background: white;\n    color: $pearl-blue;\n    height: 30px;\n    transition: 0.2s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n    width: 150px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue;\n      color: white;\n      border: none;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-reg-ghost-long {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    border: 1px solid $pearl-blue;\n    background: white;\n    color: $pearl-blue;\n    min-height: 30px;\n    transition: 0.2s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n    width: 250px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue;\n      color: white;\n      border: none;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n.action-button-80 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 80px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n.action-button-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-150 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 150px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-200 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 200px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-300 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 300px;\n    margin: 40px 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-small-trashCan {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 20px;\n    transition: 0.1s ease;\n    width: 40px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n   .action-button-cancel {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: 2px solid $pearl-blue;\n    background: $grey2;\n    background: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $grey3;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-hide-dropdown {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n\n    border: none;\n    background: $pearl-blue;\n    background: $grey2;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n    width: 100%;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .51;\n      cursor: not-allowed;\n    }\n  };\n\n    .action-button-admin {\n    @include borderRadius(3px);\n    cursor: pointer;\n    border: none;\n    background: $dashboard-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 7px;\n    font-weight: 600;\n    font-size: .85em;\n    margin-top: 10px;\n    transition: 0.1s ease-in-out;\n\n    &:hover {\n      padding-left: 30px;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n  .back-to-admin-home {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    min-width: 260px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n  };\n\n  .close-x-icon-button {\n    @include borderRadius(30px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 25px;\n    width: 25px;\n    border: none;\n    padding: 3px;\n    position: relative;\n    bottom: 20px;\n    right: 20px;\n    color: $grey3;\n    background: white;\n    border: 2px solid $grey3;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .action-button-table-edit {\n    @include borderRadius(5px);\n    width: 25px;\n    height: 25px;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n  .action-button-group {\n    @include borderRadius(3px);\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    height: 30px;\n    transition: 0.1s ease;\n    background: none;\n    border: none;\n    padding: 15px 10px;\n    font-size: 14px;\n\n    &:hover {\n      background: $grey1;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n\n\n   .action-button-circle-green {\n    @include borderRadius(3px);\n    @include shadow();\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    background: rgb(53, 148, 53);\n    color: white;\n    height: 50px;\n    width: 50px;\n    transition: 0.1s ease;\n    font-size: 40px;\n\n    &:hover {\n      transform: scale(1.02);\n      background: rgb(85, 179, 85);\n    }\n    &:disabled {\n      opacity: .5;\n      background: $grey2;\n      cursor: not-allowed;\n    }\n  };\n   .action-button-circle-red {\n    @include borderRadius(3px);\n    @include shadow();\n    display: flex;\n    justify-content: center;\n    padding-bottom: 5px;\n    align-items: center;\n    border: none;\n    background: rgb(201, 33, 3);\n    color: white;\n    height: 50px;\n    width: 50px;\n    transition: 0.1s ease;\n    font-size: 40px;\n\n    &:hover {\n      transform: scale(1.02);\n        background: rgb(234, 64, 34);\n    }\n    &:disabled {\n      opacity: .5;\n      background: $grey2;\n      cursor: not-allowed;\n    }\n  };\n\n\n  // Media queries ---------------------------------\n  @media only screen and (max-width: 1190px) {\n    .action-button-opt-out-locations {\n      font-size: 12px;\n    } \n  }\n \n  @media only screen and (max-width: 1085px) {\n    .action-button-opt-out-locations {\n      width: 160px;\n      padding: 5px;\n      height: 45px;\n    } \n  }\n  \n  @media only screen and (max-width: 1080px) {\n    .action-button-reason {\n      font-size: 0.7rem;\n      padding: 0px 8px;\n    }\n  } \n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
